
const jobStatusList = [
  {
    label: "All Status",
    value: "",
  },
  {
    label: "In Progress",
    value: "inProgress",
  },
  {
    label: "Pending",
    value: "pending",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Rejected",
    value: "rejected",
  },
  {
    label: "Assigned",
    value: "assigned",
  }];

const adStatiusList =
  [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "Active",
      value: "1",
    },
    {
      label: "Pending",
      value: "2",
    },
    {
      label: "Rejected",
      value: "3",
    },
    {
      label: "Missed",
      value: "4",
    },
    {
      label: "Expired",
      value: "5",
    },
  ]

const jobDetailServiceList = ["Major Service", "Oil & Filter Change", "Visual Inspection"];

const bookingStatus = [
  {
    label: 'All',
    value: ''
  },
  {
    label: 'Pending',
    value: 0
  },
  {
    label: 'Completed',
    value: 1
  },
  {
    label: 'Rejected',
    value: 2
  },
  {
    label: 'Accepted',
    value: 3
  },
  {
    label: 'In-Progress',
    value: 4
  },
  {
    label: 'Admin Assigned',
    value: 5
  },
]

export default {
  jobStatusList,
  jobDetailServiceList,
  adStatiusList,
  bookingStatus
};